// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./mobile-fixes.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./legacy-pages-mobile.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Reset */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Body & HTML */
html {
  font-size: 16px;
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-family);
  line-height: var(--line-height-normal);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--gradient-primary);
  min-height: 100vh;
  color: var(--color-white);
}

/* Typography */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-tight);
  margin-bottom: var(--space-md);
}

h1 {
  font-size: var(--font-size-4xl);
}

h2 {
  font-size: var(--font-size-3xl);
}

h3 {
  font-size: var(--font-size-2xl);
}

h4 {
  font-size: var(--font-size-xl);
}

p {
  margin-bottom: var(--space-md);
}

/* Links */
a {
  color: var(--color-accent);
  text-decoration: none;
  transition: color var(--transition-base);
}

a:hover {
  color: var(--color-accent-light);
}

/* Code */
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  background: var(--color-dark-light);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
}

/* Utility Classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-lg);
}

.container-wide {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--space-lg);
}

.container-narrow {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--space-lg);
}

/* Text Utilities */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-xs {
  font-size: var(--font-size-xs);
}

.text-sm {
  font-size: var(--font-size-sm);
}

.text-lg {
  font-size: var(--font-size-lg);
}

.text-xl {
  font-size: var(--font-size-xl);
}

.font-bold {
  font-weight: var(--font-weight-bold);
}

.font-semibold {
  font-weight: var(--font-weight-semibold);
}

.font-medium {
  font-weight: var(--font-weight-medium);
}

/* Spacing Utilities */
.mt-xs {
  margin-top: var(--space-xs);
}

.mt-sm {
  margin-top: var(--space-sm);
}

.mt-md {
  margin-top: var(--space-md);
}

.mt-lg {
  margin-top: var(--space-lg);
}

.mt-xl {
  margin-top: var(--space-xl);
}

.mb-xs {
  margin-bottom: var(--space-xs);
}

.mb-sm {
  margin-bottom: var(--space-sm);
}

.mb-md {
  margin-bottom: var(--space-md);
}

.mb-lg {
  margin-bottom: var(--space-lg);
}

.mb-xl {
  margin-bottom: var(--space-xl);
}

.p-xs {
  padding: var(--space-xs);
}

.p-sm {
  padding: var(--space-sm);
}

.p-md {
  padding: var(--space-md);
}

.p-lg {
  padding: var(--space-lg);
}

.p-xl {
  padding: var(--space-xl);
}

/* Flexbox Utilities */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.gap-xs {
  gap: var(--space-xs);
}

.gap-sm {
  gap: var(--space-sm);
}

.gap-md {
  gap: var(--space-md);
}

.gap-lg {
  gap: var(--space-lg);
}

.gap-xl {
  gap: var(--space-xl);
}

/* Grid Utilities */
.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

/* Loading State */
.loading-spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 4px solid var(--glass-border);
  border-top-color: var(--color-white);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-dots::after {
  content: '...';
  animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {

  0%,
  20% {
    content: '.';
  }

  40% {
    content: '..';
  }

  60%,
  100% {
    content: '...';
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fadeIn var(--transition-slow);
}

.animate-slide-up {
  animation: slideUp var(--transition-slow);
}

.animate-scale-in {
  animation: scaleIn var(--transition-slow);
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: var(--color-dark);
}

::-webkit-scrollbar-thumb {
  background: var(--color-gray);
  border-radius: var(--radius-md);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-gray-light);
}

/* Selection */
::selection {
  background: var(--color-accent);
  color: var(--color-white);
}

/* Focus Visible */
:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAIA,iBAAiB;AACjB;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;;;;;;EAME,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE;;IAEE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,mBAAmB;AACrB","sourcesContent":["@import './variables.css';\n@import './mobile-fixes.css';\n@import './legacy-pages-mobile.css';\n\n/* Global Reset */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Body & HTML */\nhtml {\n  font-size: 16px;\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-family);\n  line-height: var(--line-height-normal);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--gradient-primary);\n  min-height: 100vh;\n  color: var(--color-white);\n}\n\n/* Typography */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: var(--font-weight-bold);\n  line-height: var(--line-height-tight);\n  margin-bottom: var(--space-md);\n}\n\nh1 {\n  font-size: var(--font-size-4xl);\n}\n\nh2 {\n  font-size: var(--font-size-3xl);\n}\n\nh3 {\n  font-size: var(--font-size-2xl);\n}\n\nh4 {\n  font-size: var(--font-size-xl);\n}\n\np {\n  margin-bottom: var(--space-md);\n}\n\n/* Links */\na {\n  color: var(--color-accent);\n  text-decoration: none;\n  transition: color var(--transition-base);\n}\n\na:hover {\n  color: var(--color-accent-light);\n}\n\n/* Code */\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n  background: var(--color-dark-light);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n}\n\n/* Utility Classes */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: var(--space-lg);\n}\n\n.container-wide {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: var(--space-lg);\n}\n\n.container-narrow {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: var(--space-lg);\n}\n\n/* Text Utilities */\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-xs {\n  font-size: var(--font-size-xs);\n}\n\n.text-sm {\n  font-size: var(--font-size-sm);\n}\n\n.text-lg {\n  font-size: var(--font-size-lg);\n}\n\n.text-xl {\n  font-size: var(--font-size-xl);\n}\n\n.font-bold {\n  font-weight: var(--font-weight-bold);\n}\n\n.font-semibold {\n  font-weight: var(--font-weight-semibold);\n}\n\n.font-medium {\n  font-weight: var(--font-weight-medium);\n}\n\n/* Spacing Utilities */\n.mt-xs {\n  margin-top: var(--space-xs);\n}\n\n.mt-sm {\n  margin-top: var(--space-sm);\n}\n\n.mt-md {\n  margin-top: var(--space-md);\n}\n\n.mt-lg {\n  margin-top: var(--space-lg);\n}\n\n.mt-xl {\n  margin-top: var(--space-xl);\n}\n\n.mb-xs {\n  margin-bottom: var(--space-xs);\n}\n\n.mb-sm {\n  margin-bottom: var(--space-sm);\n}\n\n.mb-md {\n  margin-bottom: var(--space-md);\n}\n\n.mb-lg {\n  margin-bottom: var(--space-lg);\n}\n\n.mb-xl {\n  margin-bottom: var(--space-xl);\n}\n\n.p-xs {\n  padding: var(--space-xs);\n}\n\n.p-sm {\n  padding: var(--space-sm);\n}\n\n.p-md {\n  padding: var(--space-md);\n}\n\n.p-lg {\n  padding: var(--space-lg);\n}\n\n.p-xl {\n  padding: var(--space-xl);\n}\n\n/* Flexbox Utilities */\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.gap-xs {\n  gap: var(--space-xs);\n}\n\n.gap-sm {\n  gap: var(--space-sm);\n}\n\n.gap-md {\n  gap: var(--space-md);\n}\n\n.gap-lg {\n  gap: var(--space-lg);\n}\n\n.gap-xl {\n  gap: var(--space-xl);\n}\n\n/* Grid Utilities */\n.grid {\n  display: grid;\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, 1fr);\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* Loading State */\n.loading-spinner {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--glass-border);\n  border-top-color: var(--color-white);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-dots::after {\n  content: '...';\n  animation: dots 1.5s steps(4, end) infinite;\n}\n\n@keyframes dots {\n\n  0%,\n  20% {\n    content: '.';\n  }\n\n  40% {\n    content: '..';\n  }\n\n  60%,\n  100% {\n    content: '...';\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn var(--transition-slow);\n}\n\n.animate-slide-up {\n  animation: slideUp var(--transition-slow);\n}\n\n.animate-scale-in {\n  animation: scaleIn var(--transition-slow);\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-dark);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-gray);\n  border-radius: var(--radius-md);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-gray-light);\n}\n\n/* Selection */\n::selection {\n  background: var(--color-accent);\n  color: var(--color-white);\n}\n\n/* Focus Visible */\n:focus-visible {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
